
<script>

import cComponent from '../misc/cComponent'
import {wBaseMixin} from 'crud-vue-core'

export default {
  name: 'w-base',
  extends: cComponent,
  mixins: [wBaseMixin]
}
</script>

<style scoped>

</style>
